export { default as SubjectClimate } from './SubjectClimate';
export { default as SubjectEnergy } from './SubjectEnergy';
export { default as SubjectFood } from './SubjectFood';
export { default as SubjectHealth } from './SubjectHealth';
export { default as SubjectNature } from './SubjectNature';
export { default as SubjectRessources } from './SubjectRessources';
